import { render, staticRenderFns } from "./FiltroId.vue?vue&type=template&id=7b3d1d10&"
import script from "./FiltroId.vue?vue&type=script&lang=ts&"
export * from "./FiltroId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports